/**
 * A set of file extensions that are considered non-compressible by default.
 *
 * Files with these extensions are typically already compressed or do not benefit
 * significantly from further compression. This set is used to identify such files
 * and potentially skip additional compression steps during upload or processing.
 *
 * @remarks
 * Common examples include archive formats (e.g., 'zip', 'rar'), media files (e.g., 'mp3', 'mp4', 'jpg'),
 * and certain document formats (e.g., 'pdf', 'docx', 'xlsx').
 */
export const BUILT_IN_NON_COMPRESSIBLE = new Set([
  '7z',
  'aac',
  'avi',
  'avif',
  'br',
  'bz2',
  'docx',
  'flac',
  'gif',
  'gz',
  'heic',
  'jpeg',
  'jpg',
  'lz4',
  'mkv',
  'mov',
  'mp3',
  'mp4',
  'ogg',
  'pdf',
  'png',
  'pptx',
  'rar',
  'wav',
  'webm',
  'webp',
  'xlsx',
  'xz',
  'zip',
  'zst',
]);
